function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

// MEDAIS-2052: Generate QUERYID using crypto.randomUUID()
function generateQueryId() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  // Fallback to custom UUID generation if crypto.randomUUID is not available
  return generateUUID();
}

const sessUUID = String(generateUUID());

const _vars = {
	
	token: null,
	socket: null,
	conversationId: null,
	taskId: null,
	streamUrl: null,
	ranOnce: false,
	pending: false,
	draggedFlag: false,
	socketTimer: null,
	provider: null,
	correlationId: sessUUID,
	runId: null,
	queryId: null, // MEDAIS-2052: Frontend-generated QUERYID for each query
	userScrollNoTrack: false,
	userScrollNoTrackTimer: null,
	progressBTimer: null,
	progressCTimer: null,
	apiEnv: (document.domain.match(/((qa(\d+)?|dev\d+?|devint|staging)\.)/) != null ? document.domain.match(/((qa(\d+)?|dev\d+?|devint|staging)\.)/)[0].replace('qa01.','qa.').replace('dev01.','devint.') : ''),
	friendlyEnv: (document.domain.match(/((qa(\d+)?|dev\d+?|devint|staging)\.)/) != null ? document.domain.match(/((qa(\d+)?|dev\d+?|devint|staging)\.)/)[0] : ''),
	isFullPage: (document.querySelector('.ai-search-full-width-page') != null),
	isConditionPage: (document.getElementById('drugdbmain') != null),
	isOverviewPage: (document.getElementById('drugdbmain') != null) && window.location.pathname.includes('-overview'),
	promptId: null,
	isArticlePage: false,
	isArticleMobile: false,
	a2aArticleContext: null, // A2A article context captured for the current feed article
	a2aCurrentArticleGuid: null, // last A2A article queried; used to reset the thread only on article change
	// Bumped every time the reader moves to a different A2A feed article. A stream snapshots this
	// at dispatch and abandons itself if the value has moved on, so an answer for the previous
	// article can never render into (or overwrite the thread_id of) the current one.
	a2aStreamGeneration: 0,
	captureA2AArticleContext: null, // bindui sets this so shared.handleSearch can capture A2A context
	initialPromptsShimmer: true, // Feature flag for shimmer/skeleton loading effect
	isSearchResultsPage: (window.location.pathname === '/search' || window.location.pathname === '/search/') && (new URLSearchParams(window.location.search).get('q') || '').trim().length > 0,
	cfg: {
		prependElem: '#drugdbmain',
		hardcoded: ['What are the treatment options for breast cancer?', 'What are the most common adverse events for chemotherapy in breast cancer patients?', 'How to diagnose breast cancer'],
		deepDiveLinks: [
			{ id: 'clinical', text: 'See clinical implications for practice', prompt: 'What are the clinical implications of this article for practice?' },
			{ id: 'patient', text: 'Summarize this article in patient-friendly language', prompt: 'Summarize this article in patient-friendly language' }
		],
		vpScrFactor: 1,
		queryLimit: 5
	},

	searchResult: {
		question: null,
		answerId: null,
		answer: null,
		responseTime: null,
		responseTimeFirstToken: null
	},
	leadConcept: null, // Store { value: string, source: 'url'|'api' },
	queryStreamStartPerformance:null,
	queryStreamEndPerformance:null,
	querySource: 'Organic', // Track query source: 'Organic', 'Initial prompt', 'Follow up question', 'PDQ (URL)'
	// Reusable suppression pattern: any feature can set this to true immediately before calling
	// shared.handleSearch(...) to hide the Key Points card on that one query's response only.
	// It is read and cleared synchronously the instant the query is dispatched (dify/index.js:sendMessage),
	// so repeated/overlapping clicks each get their own correct value.
	suppressKeyPointsOnce: false,
}

module.exports = {
	_vars: _vars,
	generateQueryId: generateQueryId // MEDAIS-2052: Export function for generating new QUERYID
}
